import { ExclusiveGateway, BpmnModelHelper, FlowNodeState } from "@edp-pmf/bpmn-model";
import { ExclusiveGatewayCell } from "@edp-pmf/grapheditor";
import { WfConstants } from "../WfConstants";

/**
 * 排他网关节点，增加状态图片信息
 */
export class WfExclusiveGatewayCell extends ExclusiveGatewayCell {
    imgUrls = {
        [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/ExclusiveGateway.png",
        [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/ExclusiveGateway_select.svg",
    };

    createFlowElement(flowElt?: ExclusiveGateway) {
        const flowNode = super.createFlowElement(flowElt) as ExclusiveGateway;
        flowNode.Id = "ExclusiveGateway" + BpmnModelHelper.GenerateElementId();

        return flowNode;
    }
}